import {DetailExamenPageComponent} from "./../../detail-examen/detail-examen.component";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "./../../../../../../environments/environment";
import {
  ICatalogueExamenWebServiceClient,
  IFavorisWebServiceClient,
  LigneCatalogueExamenDto, RechercheExamenDto, PaginationResultDto
} from "@resources/resources";
import {
  WaitingModalService,
  WindowService,
  UserStore,
  CorrespondantStore
} from "@digicerba/common";
import {AsiDialogService, AsiFileService, AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {Router} from "@angular/router";
import {Component, Input, ViewChild, SimpleChange} from "@angular/core";
import {AsiTableRequest} from "@asi-ngtools/lib";
import {NotificationService} from "@digicerba/common";
@Component({
  selector: 'resultats-catalogue',
  templateUrl: './resultats-catalogue.component.html'
})
export class ResultatsCatalogueComponent {

  @Input() rechercheExamenDto: RechercheExamenDto;
  @Input() termsToHighlight: string;
  @Input() lang: any;

  titre_resultats: string;
  searchHasTooManyResults: boolean;
  @ViewChild('ceMisesAJourDataTable') articleTable: AsiTable<LigneCatalogueExamenDto>;
  asiTableData: AsiTableData<LigneCatalogueExamenDto> = new AsiTableData<LigneCatalogueExamenDto>();

  printing: boolean = false;
  detailOpen: boolean = false;

  constructor(private notificationService: NotificationService,
              private router: Router,
              private windowService: WindowService,
              private translateService: TranslateService,
              private favorisWebServiceClient: IFavorisWebServiceClient,
              private waitingModal: WaitingModalService,
              private fileUtils: AsiFileService,
              private asiDialogService: AsiDialogService,
              private catalogueExamenWebService: ICatalogueExamenWebServiceClient,
              private userStore: UserStore,
              private correspondantStore: CorrespondantStore) {

  }

  ngOnInit() {
    this.lang = navigator.language;
  }

  ngOnChanges(changes: SimpleChange) {
      this.articleTable.fireRefresh();
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.rechercheExamenDto = {...this.rechercheExamenDto, ...asiTableRequest};
    if (this.termsToHighlight == null) {
      this.termsToHighlight = '';
    }
    this.rechercheExamen();
  }

  private rechercheExamen() {
    this.catalogueExamenWebService.catalogueExamen(this.rechercheExamenDto).subscribe((resultats: PaginationResultDto) => {
      // affichage du message si les critères de recherches sont trop larges.
      this.searchHasTooManyResults = resultats.limitExceeded;
      this.asiTableData = {...resultats.pagination, paginate: true};

      this.articleTable.updateData(this.asiTableData);

      if (this.asiTableData.totalElements == 1) {
        this.titre_resultats = this.asiTableData.totalElements + " " + this.translateService.instant("MISES_A_JOUR.resultat");
      } else {
        this.titre_resultats = this.asiTableData.totalElements + " " + this.translateService.instant("MISES_A_JOUR.resultats");
      }
    }, error => {
      if (error.status == 422) {
        this.notificationService.showErrorNotification("TODO NOTIF");
      }
    });
  }

  icon(temperature: string): string {
    if (temperature == "CONGELE") {
      return "fa-snowflake-o";
    } else if (temperature == "REFRIGERE") {
      return "fa-tint";
    } else if (temperature == "AMBIANT") {
      return "fa-sun-o";
    }
    return null;
  }

  ajoutFavori(ligne: LigneCatalogueExamenDto): void {
    this.favorisWebServiceClient.ajoutFavori(ligne.identifiantLcds).subscribe();
    this.toggleFavori(ligne);
  }

  suppressionFavori(ligne: LigneCatalogueExamenDto): void {
    this.favorisWebServiceClient.supressionFavori(ligne.identifiantLcds).subscribe();
    this.toggleFavori(ligne);
  }

  toggleFavori(ligne: LigneCatalogueExamenDto): void {
    ligne.favori = !ligne.favori;
  }

  goDetail(id: number) {
    this.router.navigate(["/cerba/detail-examen", id]);
  }

  goUpdate(row: LigneCatalogueExamenDto) {
    this.router.navigate(["/cerba/historique-modifications", row.identifiantLcds]);
  }

  launchPrint() {
    this.waitingModal.openModal('ACTION.printing');
    setTimeout(() => {
      this.printing = true;
    }, 100);
  }

  print() {
    this.waitingModal.closeModal();
    setTimeout(() => {
      this.windowService.openPrint();
      this.printing = false;
    }, 100);
  }

  exportCsv() {
    this.waitingModal.openModal('ACTION.exportCSV');
    this.fileUtils.getFileAsBlobFromPostRequest(environment.contextPath + "api/catalogueexamen/exportLight", this.rechercheExamenDto).subscribe((fileAsBlob) => {
      this.saveToFile(fileAsBlob, "catalogue.csv");
      this.waitingModal.closeModal();
    });
}

  private saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      var anchor = document.createElement("a");
      var universalBOM = '\uFEFF';
      var csvContent = this.blobToString(fileAsBlob);
      anchor.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvContent));
      anchor.setAttribute('download', fileName);
      anchor.dispatchEvent(new MouseEvent("click"));
    }
  }

  blobToString(b) {
    var u, x;
    u = URL.createObjectURL(b);
    x = new XMLHttpRequest();
    x.open('GET', u, false);
    x.send();
    URL.revokeObjectURL(u);
    return x.responseText;
  }

  open(id: number) {
    this.catalogueExamenWebService.detailExamen(id).subscribe(detail => {
      let detailModal = this.asiDialogService.fromComponent(DetailExamenPageComponent, null);
      detailModal.getComponent().detail = detail;
      detailModal.viewContainerRef.element.nativeElement.className += " detail-dialog";
      this.detailOpen = true;

      detailModal.onDialogClose().subscribe(() => {
        this.detailOpen = false;
        this.asiTableData.results.find(o => {
          return o.id == id;
        }).favori = detailModal.getComponent().detail.favori;
      })
    });
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == "INVITE";
  }

  isFr(): boolean {
    return this.correspondantStore.hasTag("fr") && !this.correspondantStore.hasTag("en") && !this.correspondantStore.hasTag("fra");
  }

  /**
   * Check les tags du correspondant en cours pour savoir si on a
   * accès à la partie modification du catalgue examen
   *
   * @returns {boolean} true si le tag pour avoir accès est présent
   * ============================================================== */
  isAuthToCatalogUpdate(): boolean {
    return this.correspondantStore.hasTag("majcatalogue");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/resultats/resultats-catalogue.component.ts